import React, { useEffect, useState } from "react"
import { Modal, InputNumber, Form, message, Spin, Space } from "antd"
import OrderB2BService from "src/services/OrderB2BService"
import Button from "src/components/MyButton/Button"

const EditPriceModal = ({ open, onClose, pkg, onSuccess }) => {
  const [form] = Form.useForm()
  const [savingId, setSavingId] = useState(null) // lưu ID agent đang saving
  const [loadingDetail, setLoadingDetail] = useState(false)
  const [agents, setAgents] = useState([])

  // 🔹 Gọi API detail để lấy danh sách đại lý con
  const fetchDetail = async () => {
    try {
      setLoadingDetail(true)
      const res = await OrderB2BService.getPackagePriceDetail(pkg.package.ID)
      if (res.success && Array.isArray(res?.success?.children?.data)) {
        setAgents(res.success.children.data)
        const initialValues = {}
        res.success.children.data.forEach(agent => {
          initialValues[`price_${agent.ID}`] = Number(agent.price_setting) || 0
        })
        form.setFieldsValue(initialValues)
      } else {
        setAgents([])
      }
    } catch (err) {
      console.error(err)
      message.error("Không tải được danh sách đại lý")
    } finally {
      setLoadingDetail(false)
    }
  }

  useEffect(() => {
    if (open) fetchDetail()
  }, [open])

  // 🔹 Lưu giá riêng cho từng agent
  const handleSaveAgent = async agent => {
    try {
      await form.validateFields([`price_${agent.ID}`])
      const value = form.getFieldValue(`price_${agent.ID}`)

      setSavingId(agent.ID)
      const payload = {
        package_id: pkg.package.ID,
        parent_id: agent.parent_id,
        child: agent.ID,
        price: Number(value),
      }

      const res = await OrderB2BService.setOverridePackagePrice(payload)

      if (res.message?.toLowerCase().includes("thành công")) {
        message.success(`Đã lưu giá cho ${agent.fullname}`)
        onSuccess?.()
      } else {
        message.error(res.message || "Lưu thất bại")
      }
    } catch (err) {
      console.error(err)
      message.error("Có lỗi khi lưu giá bán")
    } finally {
      setSavingId(null)
    }
  }

  return (
    <Modal
      open={open}
      title={`Chỉnh sửa giá bán - ${pkg?.name}`}
      onCancel={onClose}
      footer={null}
      destroyOnClose
      width={600}
    >
      <Spin spinning={loadingDetail}>
        <Form form={form} layout="vertical">
          {agents.map(agent => (
            <div
              key={agent.ID}
              style={{
                display: "flex",
                alignItems: "flex-end",
                marginBottom: 16,
                width: "100%", // full modal
                gap: 8, // khoảng cách giữa input và nút
              }}
            >
              <Form.Item
                label={`Đại lý: ${agent.fullname}`}
                name={`price_${agent.ID}`}
                rules={[{ required: true, message: "Vui lòng nhập giá bán" }]}
                style={{ flex: 1, marginBottom: 0 }}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  formatter={value =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={value => value.replace(/[^0-9]/g, "")}
                />
              </Form.Item>

              <Button
                btnType="primary"
                loading={savingId === agent.ID}
                onClick={() => handleSaveAgent(agent)}
              >
                Lưu
              </Button>
            </div>
          ))}
        </Form>
      </Spin>
    </Modal>
  )
}

export default EditPriceModal
